import React, {Fragment, useEffect, useState} from 'react'
import localization from "../../../../../assets/localization/localization";
import TableSection from "../../../../../components/sales/tableSection/tableSection";
import Layout from "../../../../../components/sales/layout/layout";
import ModalPop from "../../../../../components/sales/modal/modal";
import ConstantInput from "../../../../../components/sales/Input/constantInput/constantInput";
import {Button} from "react-bootstrap";
import Images from "../../../../../assets/images/imageData";
import Filter from "../Filter";

const FixedInvoice = ({
                             getValetContractInvoice,
                             valetContractInvoice=[]
                         }) => {
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [closeModal, setCloseModal] = useState(false)
    const [remark, setRemark] = useState('')
    const [showFilter, setShowFilter] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getValetContractInvoice(1, 1)
            setIsLoading(false)
        })()
    }, []);

    const headers = [
        "Invoice Id",
        'Invoice Number',
        'Invoice Type',
        'Invoice Date',
        'Net Payable',
        // 'Creation Source',
        // 'status',
        'Installment Type',
        // 'Pi Number',1
        'Actions'
    ];

    useEffect(() => {
        if (valetContractInvoice && valetContractInvoice?.resultSets && valetContractInvoice?.resultSets.length > 0) {
            const tableData = ['invoice_id' ,'invoice_number','invoice_type','invoice_date','net_payable', 'installment_type'];
            const data = valetContractInvoice?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'installment_type' ? {[key]: 'Fixed'} : key === 'invoice_type' ? {[key]: element[key] === 1 ? 'Pre' : 'Post'} : {[key]: element[key]}
                    )),
                    {},
                    {Action: [
                            {name: 'View', link: `valet-fixed-invoice-view/${element['invoice_id']}`}
                        ]}
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(valetContractInvoice.total / valetContractInvoice.per_page));
        }
    }, [valetContractInvoice])

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getValetContractInvoice(val.selected + 1, 1);
        setIsLoading(false);
    };

    const applyFilter = async (filterData) => {
        setIsLoading(true);
        localStorage.setItem("valet_invoice_b2b", JSON.stringify(filterData));
        await getValetContractInvoice(1, 1, filterData);
        setIsLoading(false);
        filterToggle();
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const headerBtns = () => {
        return (
            <>
                <Fragment>
                    <Button
                        onClick={filterToggle}
                        className="filter-hamburger btn btn-transparent"
                    >
                        <img src={Images?.Filter} alt=""></img>
                        {localization.showFilters}
                    </Button>
                </Fragment>
            </>
        );
    };

    return (
        <>
            <Layout
                title={localization.FixedValetInvoice}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={valetContractInvoice && valetContractInvoice.resultSets}
                    srNo={valetContractInvoice?.from}
                />
            </Layout>

            <Filter
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
            />
        </>
    )
}

export default FixedInvoice